const SESSION_KEY = 'opraiz:diya-session'

function sessionId() {
  try {
    const existing = localStorage.getItem(SESSION_KEY)
    if (existing && /^[a-zA-Z0-9-]{8,64}$/.test(existing)) return existing
    const fresh = crypto.randomUUID()
    localStorage.setItem(SESSION_KEY, fresh)
    return fresh
  } catch {
    return `diya-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}`
  }
}

export async function askDiya({ message, history = [] }) {
  const body = JSON.stringify({
    sessionId: sessionId(),
    messages: [
      ...history
        .slice(-6)
        .map((m) => ({ role: m.role === 'diya' ? 'assistant' : 'user', content: m.content })),
      { role: 'user', content: String(message).slice(0, 1200) },
    ],
  })

  let res
  try {
    res = await fetch('/api/diya', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
    })
  } catch {
    throw new Error('Network trouble between you and Diya. Check your connection and try again.')
  }

  if (res.status === 429) {
    throw new Error(
      'You are sending messages faster than Diya can think. Pause a few seconds and try again.'
    )
  }
  if (res.status === 503 || res.status === 502) {
    throw new Error(
      "Diya's mind is warming up. Try again in a moment, or reach the team at sales@opraiz.com."
    )
  }
  if (!res.ok) {
    throw new Error(
      'Diya could not process that. Try rephrasing, or reach the team at sales@opraiz.com.'
    )
  }

  const data = await res.json()
  if (!data || typeof data.reply !== 'string' || !data.reply.trim()) {
    throw new Error(
      'Diya returned an empty reply. Try again, or reach the team at sales@opraiz.com.'
    )
  }
  return { reply: data.reply, handoff: data.handoff === true }
}

export function diyaHealth() {
  return fetch('/api/diya', { method: 'GET' })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
}
